import { InjectionToken, Provider } from '@angular/core';
import getEnvironmentSettings from '../../commons/configs/env-conf-loader';
const ENVIRONMENT_SETTINGS = getEnvironmentSettings();

export const JANUS_URL = new InjectionToken<string>("JANUS_URL");
export const JanusUrlProvider: Provider = {
    provide: JANUS_URL,
    useValue: ENVIRONMENT_SETTINGS.janusUrl
}